<template>
    <div class="question collapse" :class="{'open':open}">
        <div class="left">
            <div class="collapse-header" @click="toggleCollapse">
                <div class="line nm">
                    <div class="drag">
                        <svg>
                            <use xlink:href="#icon-drag"></use>
                        </svg>
                    </div>
                    Question {{questionNumber(k)}}
                </div>
                <div v-show="!open" class="question-content" v-html="questionLabel" :class="questionError"></div>
            </div>
            <div v-show="open">
                <div class="line">
                    <vue-editor :value="question.label" placeholder="Contenu de la question"
                              @blur="updateQuestions($event)" :editor-toolbar="customToolbar"></vue-editor>
                </div>
                <div class="line">
                    <vue-editor v-model="question.text"  :editor-toolbar="customToolbar"
                                placeholder="Texte supplémentaire (facultatif)"></vue-editor>
                </div>

                <div class="mb">
                    <label> Type de réponse : </label>
                    <select v-model="questionType">
                        <option value="none">Sans réponse</option>
                        <option value="text">Texte simple</option>
                        <option value="textarea">Texte multilignes</option>
                        <option value="checkbox">Case à cocher à choix multiple (Interrupteur)</option>
                        <option value="select">Liste déroulante (Combo)</option>
                    </select>
                </div>

                <checkbox v-if="isCkeckbox()" :content="question.content" @update="updateCheckbox"></checkbox>

                <div class="checkbox mb" v-if="questionType !== 'none'">
                    <input type="checkbox" v-model="question.require" :id="'required_'+k">
                    <label :for="'required_'+k">Réponse obligatoire</label>
                </div>
                <div class="checkbox" v-if="questionType !== 'none'">
                    <input type="checkbox" v-model="question.resume" :id="'resume_'+k">
                    <label :for="'resume_'+k">Affichage résumé</label>
                </div>

                <div class="line option" v-if="edit">

                </div>
                <div class="line option" v-if="edit">
                    <btn ico="download" text="Insérer" @click="insert" color="blue"></btn>
                    <btn ico="copy" text="Dupliquer" @click="copy" color="blue"></btn>
                    <btn ico="delete" text="Supprimer" @click="remove" color="red" v-if="k > 0"></btn>
                </div>
            </div>

        </div>
        <div class="right">
            <div v-show="open" v-if="conditionActive && open">
                <conditions :conditions="question.conditions" :question="question" :questionK="k"
                            :edit="edit"></conditions>
            </div>
            <div v-show="!open" v-if="conditionActive" v-html="conditionText" style="line-height: 25px"></div>
            <div v-if="!conditionActive" style="line-height: 25px">
                <p class="badge-small"><i>Conditions masquées</i></p>
            </div>
        </div>
    </div>

</template>

<script>
    import Btn from "@/components/Btn";
    import Conditions from "@/components/questionnaire/Conditions";
    import Checkbox from "@/components/questionnaire/Checkbox";
    import tools from '../../config.ts';
    import { VueEditor } from "vue2-editor";

    export default {
        name: "Question",
        components: {Checkbox, Conditions, Btn, VueEditor},
        props: {
            question: {},
            edit: false,
            conditionActive:true,
            k: 0,
        },
        data() {
            return {
                open: false,
                customToolbar:[
                    "bold","italic","underline","link",{list:"ordered"},{list:"bullet"},"image"
                ],
                fixTextarea :0
            }
        },
        methods: {
            remove() {
                this.$emit("remove", this.k)
            },
            copy() {
                this.$emit("copy", this.k)
            },
            insert() {
                this.$emit("insert", this.k)
            },
            isCkeckbox() {
                return this.questionType === 'checkbox' || this.questionType === 'radio' || this.questionType === 'select'
            },
            updateQuestions(quill) {
                console.log(quill)
                // console.log(quill);
                // console.log(quill.getText());
                // console.log(quill.root.innerHTML);
                // this.question.text = quill.getText();
                this.question.label = quill.container.firstChild.innerHTML;
                this.question.labelText = quill.getText();
                // this.question.label = quill.getText();

                console.log(this.question.label)
                tools.$emit("updateQuestions")
            },
            toggleCollapse() {
                this.open = !this.open;
            },
            updateCheckbox(content){
                this.question.content = content;

                tools.$emit("updateQuestions")
            },
            questionNumber(k) {
                return (k + 1);
                // if (this.$store.getters.getCurrentQuestions[k].conditions.length <= 0) {
                //     return (k + 1);
                // }
                //
                // let questionK = "";
                // this.$store.getters.getCurrentQuestions[k].conditions.forEach((condition, key) => {
                //
                //     if (questionK !== "") {
                //         for (let i = 0; i < this.$store.getters.getCurrentQuestions.length; i++) {
                //
                //             if (this.$store.getters.getCurrentQuestions[i].id === condition.question) {
                //
                //                 questionK = this.questionNumber(i);
                //
                //                 break;
                //             }
                //         }
                //     }
                //
                // });
                //
                // return questionK

            }
        },
        computed: {
            questionType: {
                set(value) {
                    this.question.content = [{value: ""}];
                    this.question.type = value;
                },
                get() {
                    return this.question.type;
                }
            },
            questions() {
                return this.$store.getters.getCurrentQuestions;
            },
            conditionText() {
                if (this.k === 0) {
                    return "<i>Condition non disponible pour la première question</i>"
                }
                let text = "<p>"
                this.question.conditions.forEach((condition, key) => {

                    let questionK = 0;
                    let question = this.questions.filter((question, k) => {

                        if (question.id === condition.question && questionK === 0) {
                            // console.log(k+" | "+question.id+" | "+question.label);
                            questionK = k;
                            return question
                        }

                    })[0];

                    if (!question) {
                        return "";
                    }

                    let label = question.labelText
                    if(!label){
                        label = question.label;
                    }

                    text += '<a title="' + label + '">Question ' + this.questionNumber(questionK) + '</a>';

                    switch (condition.responses.equal) {
                        case "equal" :
                            text += " éqale ";
                            break;
                        case "not-equal" :
                            text += " différent ";
                            break;
                        case "contain" :
                            text += " contient ";
                            break;
                        case "not-contain" :
                            text += " ne contient pas ";
                            break;
                    }

                    let value = condition.responses.value;

                    if(!value){
                        value = "(vide)";
                    }

                    text += '<b>' + value + '</b>';

                    // pattern AND OR
                    if (!this.question.pattern) {
                        text += "<br/><b>ET</b><br/>";
                    } else {
                        let regex = new RegExp("condition_" + (key + 1) + " ?([ETOU]+)?");
                        let res = this.question.pattern.match(regex);
                        if (res) {
                            text += res[1] ? "<br/><b>" + res[1] + "</b><br/>" : "<br/><b>ET</b><br/>";
                        }
                    }

                });

                if (text !== "<p>") {
                    text = text.substr(0, text.length - 19);
                } else {
                    text += "<i>La question est toujours visible, aucune condition.</i>";
                }

                return text + "</p>";

            },
            questionLabel() {

                if (!this.question.label) {
                    return "<i style='font-style:italic'>Question vide</i>";
                }

                return tools.nl2br(this.question.label)
            },
            questionError() {

                if(this.question.labelText && this.question.labelText === ""){
                    return "error";
                }

                if (!this.question.label) {
                    return "error"
                }
                return "";
            },
        },
        mounted() {
            if (this.k === 0) {
                this.open = true;
            }
            if (this.question.open === true) {
                this.open = true;
                delete this.question.open;
            }
        }
    }
</script>

<style>

</style>